import { render } from "./Banner.vue?vue&type=template&id=952e5b3a&scoped=true"
import script from "./Banner.vue?vue&type=script&lang=ts"
export * from "./Banner.vue?vue&type=script&lang=ts"

import "./Banner.vue?vue&type=style&index=0&id=952e5b3a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-952e5b3a"

export default script